import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { hasPermissions } from "@app2/shared/util";
import { map } from "rxjs/operators";
import { UserService } from "@app2/account/user.service";
import { Observable } from "rxjs";

export const permissionsRequiredGuard: CanActivateFn =
    (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> =>  {
        const userService = inject(UserService);
        const router = inject(Router);

        return userService.getCurrentPermissions$()
            .pipe(map(permissions => {
                if (typeof route.data.permissionsRequired === "string") {
                    if (hasPermissions(route.data.permissionsRequired, permissions)) {
                        return true;
                    }
                } else if (typeof route.data.permissionsRequired === "function") {
                    if (route.data.permissionsRequired(permissions, route)) {
                        return true;
                    }
                } else {
                    // eslint-disable-next-line no-console
                    console.error("Unexpected type for guard's data: ",
                        typeof route.data.permissionsRequired,
                        route.data.permissionsRequired);
                }

                const queryParams = { url: state.url };
                return router.createUrlTree(["/unauthorized"], { queryParams });
            }));
    };
